import React, { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as MdOutlineWorkspacePremium } from '../../assets/icons/premium.svg'
import {
  ItemsList,
  ItemContainer,
  ItemWrapper,
  ItemName,
  LifetimeSidebarBadge,
} from '../SideBar/styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import useGetAppRoutes from '../../hooks/use-get-app-routes'
import { RoutesIcons } from './data'
interface SidebarItemsProps {
  displaySidebar: boolean
  isMobile?: boolean
}

const SidebarItems: React.FC<SidebarItemsProps> = ({ displaySidebar, isMobile }) => {
  const routes = useGetAppRoutes()

  const { pathname } = useLocation()
  const { subscriptions, status } = useSelector((state: RootState) => state.subscription)

  const isUserLifetimeSubscriber = useMemo(() => {
    if (status === 'success') {
      return subscriptions.some(
        (subscription) =>
          subscription.name === 'Assinatura Vitalícia' ||
          subscription.name === 'Assinatura Vitalícia Premium'
      )
    } else {
      return false
    }
  }, [status, subscriptions])

  return (
    <>
      <ItemsList isMobile={isMobile}>
        {routes.map(
          (route) =>
            route.active && (
              <ItemContainer
                key={route.path}
                active={route.path === pathname || pathname.startsWith(route.path + '/')}
              >
                <Link to={route.path}>
                  <ItemWrapper displaySidebar={displaySidebar}>
                    {RoutesIcons[route.path]}
                    <ItemName displaySidebar={displaySidebar}>{route.name}</ItemName>{' '}
                  </ItemWrapper>
                </Link>
              </ItemContainer>
            )
        )}
      </ItemsList>
      {isUserLifetimeSubscriber && (
        <LifetimeSidebarBadge>
          <div className="badgeContainer">
            <MdOutlineWorkspacePremium />
            <div className="badgeText">
              <strong>Você é um assinante vitalício</strong>
              <span>
                Como vitalício, você possui acesso aos benefícios mais exclusivos que o Direção
                oferece!
              </span>
            </div>
          </div>
        </LifetimeSidebarBadge>
      )}
    </>
  )
}

export default SidebarItems
